import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { MotivoGuiaRemisionSelect } from 'sharedComponents/select'

const MotivoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='MOTIVO' htmlFor='select-codigoMotivo' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='codigoMotivo'>
          {({ field }) => (
            <MotivoGuiaRemisionSelect
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-codigoMotivo'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MotivoFormGroup)
